/**
 * File family-values.js.
 * Handles logic for the Family Values template.
 */

const fvSlider = document.querySelector('.family-values__slides');
const fvFacts = document.querySelector('.family-values__facts-wrapper');
const fvArrowPrev = document.querySelector('.family-values__slider-arrow--prev');
const fvArrowNext = document.querySelector('.family-values__slider-arrow--next');
const stickyCta = document.querySelector('.sticky-cta');
let viewport = typeof isMobile == 'function' && isMobile();

const fvFactsOptions = {
  infinite: false,
  fade: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: false,
  autoplay: false,
  lazyLoad: 'anticipated',
  arrows: false,
  mobileFirst: true,
  variableWidth: true,
  responsive: [
    {
      breakpoint: 860,
      settings: "unslick"
    }
  ]
}

function familyValuesSlider($) {
  $(fvSlider).slick({
    infinite: false,
    fade: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: false,
    variableWidth: true,
    autoplay: false,
    pauseOnDotsHover: true,
    lazyLoad: 'anticipated',
    prevArrow: fvArrowPrev,
    nextArrow: fvArrowNext,
  });

  $(fvFacts).slick(fvFactsOptions);

  // if needed, re-slick unslicked slider
  $(window).on('resize', function() {
    const bIsMobile = typeof isMobile == 'function' && isMobile();
    if ((viewport !== bIsMobile) && !$(fvFacts).hasClass('slick-initialized')) {
      $(fvFacts).slick(fvFactsOptions);
      viewport = bIsMobile;
    }
  });
}

function toggleStickyCta() {
  const startEl = document.querySelector('.sub-navigation');
  const endEl = document.querySelector('.family-values__banner');
  const belowSubnav = window.scrollY > (startEl.offsetTop + startEl.offsetHeight);
  const aboveCta = endEl.offsetTop - window.scrollY > 0;
  
  if (belowSubnav && aboveCta) {
    stickyCta.classList.add('sticky-cta--visible');
  } else {
    stickyCta.classList.remove('sticky-cta--visible');
  }
}


// Inits
if (typeof jQuery !== 'undefined') jQuery(document).ready(function ($) {
  familyValuesSlider($);
});

if (stickyCta) {
  window.addEventListener('scroll', toggleStickyCta);
}

const retailerLink = document.querySelector('.family-values__hero-retailers--link');

function scrollToModule(name, index) {
  const module = document.querySelector('.module[data-name="' + name + '"][data-index="' + index + '"]');

  module.scrollIntoView({
    behavior: 'smooth' 
  });
}

retailerLink.addEventListener('click', function() {
  const name = retailerLink.dataset.moduleName;
  const index = retailerLink.dataset.moduleIndex;
  scrollToModule(name, index);
});

window.addEventListener("load", function () {

  /**
   * Init map at SF or clients location if they allow
   */
  const initLat = 37.7749;
  const initLng = -122.4194;
  const minZoom = 8;
  const defZoom = 13;
  let updatedLoc;

  initMap(initLat, initLng);
  
  // Check if geolocation available
  if ("geolocation" in navigator) {
    navigator.geolocation.getCurrentPosition(function (position) {
      const geoLat = position.coords.latitude;
      const geoLng = position.coords.longitude;
      initMap(geoLat, geoLng);
    });
  }

  let tryagainIM = true;

  function initMap(initLat, initLng) {
    if (typeof google == 'undefined') {
      if (tryagainIM) {
        tryagainIM = false;
        setTimeout(() => {
          initMap(initLat, initLng);
        }, 200);
      }
      return;
    }
    
    const geocoder = new google.maps.Geocoder();
    const latlng = new google.maps.LatLng(initLat, initLng);
    const hidePoi = [
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
    ];
    const mapOptions = {
      zoom: defZoom,
      minZoom: minZoom,
      center: latlng,
      styles: hidePoi,
      mapTypeControl: false,
      streetViewControl: false,
    };
    const map = new google.maps.Map(
      document.getElementById("gmap"),
      mapOptions
    );
    const infoWindow = new google.maps.InfoWindow();

    // Search map
    document
      .querySelector(".atm-search")
      .addEventListener("submit", function (event) {
        codeAddress();
        // Stop page from refreshing
        event.preventDefault();
      });

    function codeAddress() {
      const address = document.getElementById("address").value;
      geocoder.geocode({ address: address }, function (results, status) {
        if (status == "OK") {
          // Update map to searched location
          updatedLoc = results[0].geometry.location;
          map.setCenter(updatedLoc);
        }
      });
    }

    // Display results
    function showResults(json) {

      // Display marker for each data result
      for (let i = 0; i < json.length; i++) {

        let location = json[i];
        let address = location['Address'];
        let city = location['City'];
        let state = location['State'];
        let zip = location['Zip'];
        let coords = location['Coords'].split(' ');

        // Set map marker based on types
        var marker = new google.maps.Marker({
          position: new google.maps.LatLng(coords[0], coords[1]),
          map: map,
          icon: {
            url: theme + "/images/map/walgreens.png",
            scaledSize: new google.maps.Size(35, 42),
          },
        });

        // Display info window on marker click.
        const infoWindowContent =
          `<div id="infowindow">` +
          `<h3>Walgreens</h3>` +
          `<p>${address}<br>${city}, ${state}, ${zip.substring(0, 5)}</p>` +
          `</div>`;
        marker.html = infoWindowContent;
        google.maps.event.addListener(marker, "click", function () {
          infoWindow.close();
          infoWindow.setContent(this.html);
          infoWindow.open(map, this);
          google.maps.event.addListener(map, "click", function () {
            infoWindow.close();
          });
        });
      }
    }

    // get JSON for Walgreens locations
    async function printJSON() {
      const response = await fetch(theme + "/json/walgreens.json");
      const json = await response.json();
      showResults(json);
    }

    // Init location markers
    printJSON();
  }
});
